// Detector de conexión zombie del hub `/hub/tpv` (sin React, testeable).
//
// El servidor manda `beacon` cada 30 s. Si el socket dice "Connected" pero no
// llega NADA (ni evento ni beacon) en ZOMBIE_AFTER_MS, el cliente no está
// recibiendo aunque lo parezca → `onZombie()` (reiniciar la conexión).
//
// Solo se arma tras el PRIMER beacon de cada conexión: con un API antiguo que
// no manda beacons, un local sin actividad no es un zombie. Una conexión nueva
// (reconexión / reinicio) se desarma hasta su primer beacon.
import { ZOMBIE_AFTER_MS } from "./staleStatus";

export const LIVENESS_CHECK_MS = 5_000;

export function createLivenessWatchdog({
  isConnected,
  onZombie,
  zombieAfterMs = ZOMBIE_AFTER_MS,
  checkMs = LIVENESS_CHECK_MS,
  now = () => Date.now(),
} = {}) {
  let armed = false;
  let lastSeenAt = null;
  let lastCheckAt = null;

  return {
    /** Llegó un sobre `evt`. */
    event() {
      lastSeenAt = now();
    },
    /** Llegó un `beacon`: arma el detector en esta conexión. */
    beacon() {
      lastSeenAt = now();
      armed = true;
    },
    /** Conexión nueva: espera a su primer beacon. */
    reset() {
      armed = false;
      lastSeenAt = now();
    },
    isArmed: () => armed,

    /** Llamar periódicamente. Devuelve true si declaró zombie la conexión. */
    check() {
      const t = now();
      const slept = lastCheckAt != null && t - lastCheckAt > checkMs * 3;
      lastCheckAt = t;
      // El navegador congeló los timers (segundo plano): no juzgamos con un
      // reloj que no corría; la vuelta de segundo plano ya reinicia sockets.
      if (slept) {
        lastSeenAt = t;
        return false;
      }
      if (!armed || lastSeenAt == null) return false;
      if (!isConnected?.()) return false;
      if (t - lastSeenAt < zombieAfterMs) return false;
      const silentMs = t - lastSeenAt;
      armed = false; // hasta el primer beacon de la conexión nueva
      lastSeenAt = t;
      try {
        onZombie?.({ silentMs });
      } catch {
        /* noop */
      }
      return true;
    },
  };
}
